import { useCallback } from 'react'
import { useDialogState } from '@user/utils/useDialogState'
import { toast } from '@sales-center/components'
import { permissionDenied } from '@user/store/authorization/permissions'

type Props = {
  canUpdateEntity: boolean
  anyInvalid: boolean
  onSave: () => void
}

export function useHandlers(props: Props) {
  const { canUpdateEntity, anyInvalid, onSave } = props
  const [open, onOpen, onClose] = useDialogState()

  const [openNewLocation, onOpenNewLocation, onCloseNewLocation] =
    useDialogState()

  const handleMatchLocation = useCallback(() => {
    if (canUpdateEntity) {
      onOpen()
    } else {
      toast.error(permissionDenied)
    }
  }, [canUpdateEntity, onOpen])

  const handleCreateNewLocation = useCallback(() => {
    if (canUpdateEntity) {
      if (anyInvalid) {
        onOpenNewLocation()
      } else {
        onSave()
      }
    } else {
      toast.error(permissionDenied)
    }
  }, [onOpenNewLocation, anyInvalid, canUpdateEntity, onSave])

  return {
    handleMatchLocation,
    handleCreateNewLocation,
    onClose,
    open,
    openNewLocation,
    onCloseNewLocation,
    onOpenNewLocation,
  }
}
